import { Editor, Element, Node, Path, Point, Range, TextUnit } from 'slate';
import { isTag } from './navigation';
import { getBlockTagIds } from '../types/block';

const tagIdsOf = (node: Node): string[] => (isTag(node) ? [node.tagId] : Element.isElement(node) ? getBlockTagIds(node) : []);

const blockContains = (editor: Editor, node: Node, path: Path, at: Range) =>
  Element.isElement(node) && Editor.isBlock(editor, node) && Path.isAncestor(path, at.anchor.path) && Path.isAncestor(path, at.focus.path);

export const tagIdsIn = (editor: Editor, at: Range): Set<string> => {
  const ids = new Set<string>();
  for (const [node, path] of Editor.nodes(editor, { at })) {
    if (blockContains(editor, node, path, at)) continue;
    for (const id of tagIdsOf(node)) ids.add(id);
  }
  return ids;
};

export const collapsedDeletionRange = (editor: Editor, point: Point, direction: 'backward' | 'forward', unit: TextUnit): Range => {
  const other = direction === 'backward' ? Editor.before(editor, point, { unit }) : Editor.after(editor, point, { unit });
  return { anchor: other ?? point, focus: point };
};

export const removedTagIds = (editor: Editor, candidates: Set<string>): string[] => {
  if (candidates.size === 0) return [];
  const present = new Set<string>();
  const scan = (at: Path) => {
    for (const [node] of Editor.nodes(editor, { at })) for (const id of tagIdsOf(node)) if (candidates.has(id)) present.add(id);
  };
  const block = editor.selection && Editor.above(editor, { at: editor.selection, match: (n) => Element.isElement(n) && Editor.isBlock(editor, n) });
  const nearby = block ? [block[1], ...(block[1].length > 0 ? [Path.parent(block[1])] : [])] : [];
  for (const at of [...nearby, []]) {
    if (present.size === candidates.size) break;
    scan(at);
  }
  return [...candidates].filter((id) => !present.has(id));
};
